import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const MediaPlaySVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <circle cx="24" cy="24" r="24" fill="#EEF1FC" />
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.6314 22.1999L21.1314 15.9023C20.8128 15.7109 20.4491 15.6075 20.0774 15.6027C19.7058 15.5979 19.3395 15.6918 19.016 15.8748C18.6926 16.0579 18.4234 16.3235 18.2362 16.6445C18.0489 16.9656 17.9502 17.3306 17.9502 17.7023V30.3023C17.9502 30.6739 18.0489 31.0389 18.2362 31.36C18.4234 31.681 18.6926 31.9467 19.016 32.1297C19.3395 32.3127 19.7058 32.4066 20.0774 32.4018C20.4491 32.397 20.8128 32.2936 21.1314 32.1023L31.6314 25.7999C31.942 25.6132 32.1991 25.3493 32.3775 25.0339C32.5559 24.7185 32.6497 24.3623 32.6497 23.9999C32.6497 23.6375 32.5559 23.2812 32.3775 22.9658C32.1991 22.6504 31.942 22.3865 31.6314 22.1999Z"
          fill="#254DDA"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16.8" height="16.8" fill="white" transform="translate(16.7998 15.6001)" />
        </clipPath>
      </defs>
    </svg>
  </span>
);

export default MediaPlaySVG;
